<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('quotation.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('quotation.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker v-model="dateRange" :allowClear="false" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              style="width: 200px" @change="fetchData()" />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input v-tooltip="$t('quotation.search')" v-model="search" :placeholder="$t('search')"
              style="width: 250px" class="inline-block" />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('quotation.branch') }}</label>
                  <ts-branch-filter @filter="branchFilter" class="ts-w-full"></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :rowGroup="{
          field: 'quotation_date'
        }">
          <template v-slot="{ record }">
            <td>{{ record.branch.branch_name_en }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.quotation_no }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.customer.customer_name }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.project_name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.person_in_charge }}</td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{
                record.discount_type && record.discount_rate
                  ? record.discount_type + ' ' + record.discount_rate
                  : 'N/A'
              }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ $defaultCurrencyWithCode(record.sub_total) }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ $defaultCurrencyWithCode(record.grand_total) }}
            </td>
            <td class="ts-text-right ts-whitespace-no-wrap">
              <a href="#" v-tooltip="$t('quotation.reprint')" class="text-primary text-red mr-2"
                @click.prevent="reprintReport(record)">
                <i class="fas fa-file-pdf"></i>
              </a>
              <!-- <a
                v-if="!record.is_confirmed"
                href="#"
                v-tooltip="$t('quotation.confirmToSaleContract')"
                class="text-primary mr-2"
                @click.prevent="confirmToSale(record)"
              >
                <i class="fas fa-clipboard-check"></i>
              </a> -->
              <a href="#" v-tooltip="$t('edit')" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
                :cancel-text="$t('no')" @confirm="deleteRecord(record)">
                <a href="#" :disabled="record._deleting">
                  <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal :title="$t('quotation.confirmToSaleContract')" width="50%" v-model="show_confirm_form" :footer="null"
        fullscreen>
        <div class="row">
          <div class="col-md-12 form-group">
            <label class="required">{{ $t('quotation.confirmDate') }}</label>
            <a-date-picker v-model="confirmData.confirm_date" :allowClear="false" format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY" class="ts-w-full"></a-date-picker>
            <div class="validate" v-if="errors.has('confirm_date')">
              {{ errors.first('confirm_date') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group">
            <ts-preview-pdf v-model="waiting" :src="src" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-space-x-3 ts-flex ts-justify-end">
            <ts-button @click.prevent="() => (show_confirm_form = false)">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button color="primary" :waiting="waiting" @click.prevent="confirmToSaleSave">
              {{ $t('save') }}
            </ts-button>
          </div>
        </div>
      </a-modal>
      <a-modal :title="$t('pdf')" width="60%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Reason from './components/reason_delete'
import moment from 'moment'

export default {
  name: 'quotation',
  components: {
    Reason
  },
  data() {
    return {
      loading: false,
      show_confirm_form: false,
      waiting: false,
      show_pdf: false,
      src: '',
      model: {
        deleted_reason: null
      },
      confirmData: {
        quotation_id: '',
        confirm_date: moment().format('DD-MM-YYYY')
      },
      errors: new Errors()
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('wholesale/quotation', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.wholesale.quotation.search
      },
      set(newValue) {
        this.$store.commit('wholesale/quotation/SET_SEARCH', newValue)
        this.$store.commit('wholesale/quotation/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.quotation.dateRange
      },
      set(newValue) {
        this.$store.commit('wholesale/quotation/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('quotation.branch') },
        { name: this.$t('quotation.quotationNO') },
        { name: this.$t('quotation.customer') },
        { name: this.$t('quotation.projectName') },
        { name: this.$t('quotation.pic') },
        { name: this.$t('quotation.discount'), style: 'text-align:center' },
        { name: this.$t('quotation.subTotal'), style: 'text-align:right' },
        {
          name: this.$t('quotation.grandTotal'),
          style: 'text-align:right'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:left; width:7%'
        }
      ]
    }
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'quotation-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/quotation/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('wholesale/quotation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'quotation-edit',
        params: { id: record.quotation_id }
      })
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('quotation.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch('wholesale/quotation/destroy', {
              id: record.quotation_id,
              data: this.model
            })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() { }
      })
    },
    confirmToSale(record) {
      this.src = ''
      this.show_confirm_form = true
      this.confirmData.quotation_id = record.quotation_id
    },
    confirmToSaleSave() {
      this.waiting = true
      this.$store
        .dispatch('wholesale/quotation/confirmSale', this.confirmData)
        .then(response => {
          this.src = response.url
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting = false
        })
    },
    reprintReport(record, template) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('wholesale/quotation/reprint', {
          quotation_id: record.quotation_id,
          template: template
        })
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    branchFilter(value) {
      this.$store.commit('wholesale/quotation/SET_BRANCH_ID', value)
      this.fetchData()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/quotation/RESET_STATE')
    next()
  }
}
</script>

<style scoped></style>
